import { ShipmentItem } from '@app/api/shipments/types';
import { Alert } from 'easyship-components';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { twMerge } from 'tailwind-merge';
import ButtonSeeDetails from './ButtonSeeDetails';
import ClaimState from '../ClaimState';

function ClaimDetails({ claim }: { claim: NonNullable<ShipmentItem['claim']> }) {
  return (
    <div className="w-full space-y-5">
      <div
        className={twMerge(
          'grid gap-2 place-items-start place-content-center text-base grid-cols-[40%_1fr]'
        )}
      >
        <div className="text-ink-500">
          <FormattedMessage id="insurance-claim.claim-dialog.claim-status" />
        </div>
        <div className="text-ink-900">
          <ClaimState
            state={claim.reviewState === 'approved' ? claim.paymentState : claim.reviewState}
          />
        </div>

        <div className="text-ink-500">
          <FormattedMessage id="insurance-claim.claim-dialog.submission-date" />
        </div>
        <div className="text-ink-900">
          <FormattedDate
            value={claim.providerClaimFiledDate}
            dateStyle="medium"
            timeStyle="short"
          />
        </div>

        <div className="text-ink-500">
          <FormattedMessage id="insurance-claim.claim-dialog.claim-id" />
        </div>
        <div className="text-ink-900">
          {claim.easyshipClaimId || <FormattedMessage id="global.not-available" />}
        </div>

        <div className="text-ink-500">
          <FormattedMessage id="insurance-claim.claim-dialog.issue-type" />
        </div>
        <div className="text-ink-900">
          <FormattedMessage
            id={
              claim.claimType
                ? `shipments.modal.claim-summary.${claim.claimType}`
                : 'global.not-available'
            }
          />
        </div>

        <div className="text-ink-500">
          <FormattedMessage id="insurance-claim.claim-dialog.photo-evidence" />
        </div>
        <div className="text-ink-900">
          <FormattedMessage
            id="shipments.modal.claim-summary.photos"
            values={{ count: claim.allFiles.length }}
          />
        </div>
      </div>

      <ButtonSeeDetails />

      {claim.claimType === 'damaged_or_missing' && (
        <Alert severity="info" contentClassName="text-left">
          <FormattedMessage id="insurance-claim.claim-dialog.damage-notice" />
        </Alert>
      )}
    </div>
  );
}

export default ClaimDetails;
